export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/3dprintingservice": [3],
		"/3dprintingservice/dashboard": [4],
		"/ai": [13],
		"/change-password": [14],
		"/comingsoon/3dprinting": [15],
		"/comingsoon/ai": [16],
		"/menu-bar": [17],
		"/patchupdate": [~18],
		"/pay": [19],
		"/pricing": [20],
		"/profile": [21],
		"/test": [22],
		"/validate-payment": [23],
		"/[lang]": [5],
		"/[lang]/3dprintingservice": [6],
		"/[lang]/3dprintingservice/dashboard": [7],
		"/[lang]/ai": [8],
		"/[lang]/change-password": [9],
		"/[lang]/policy": [10],
		"/[lang]/profile": [11],
		"/[lang]/termandcondition": [12]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';